export interface Avatar {
    readonly id: string;
    readonly etiqueta: string;
    readonly genero: 'hombre' | 'mujer';
}

export const DEFAULT_AVATAR = 'avatar-01';

export const AVATARES: readonly Avatar[] = [
    { id: 'avatar-01', etiqueta: 'Avatar 1', genero: 'hombre' },
    { id: 'avatar-02', etiqueta: 'Avatar 2', genero: 'hombre' },
    { id: 'avatar-03', etiqueta: 'Avatar 3', genero: 'hombre' },
    { id: 'avatar-04', etiqueta: 'Avatar 4', genero: 'hombre' },
    { id: 'avatar-05', etiqueta: 'Avatar 5', genero: 'hombre' },
    { id: 'avatar-06', etiqueta: 'Avatar 6', genero: 'hombre' },
    { id: 'avatar-07', etiqueta: 'Avatar 7', genero: 'hombre' },
    { id: 'avatar-08', etiqueta: 'Avatar 8', genero: 'mujer' },
    { id: 'avatar-09', etiqueta: 'Avatar 9', genero: 'mujer' },
    { id: 'avatar-10', etiqueta: 'Avatar 10', genero: 'mujer' },
    { id: 'avatar-11', etiqueta: 'Avatar 11', genero: 'mujer' },
    { id: 'avatar-12', etiqueta: 'Avatar 12', genero: 'mujer' },
    { id: 'avatar-13', etiqueta: 'Avatar 13', genero: 'mujer' },
    { id: 'avatar-14', etiqueta: 'Avatar 14', genero: 'mujer' }
];

/** Las rutas de imágenes siempre proceden del catálogo local. */
export function normalizarAvatarId(avatar: unknown): string {
    return typeof avatar === 'string' && AVATARES.some((opcion) => opcion.id === avatar) ? avatar : DEFAULT_AVATAR;
}

export function obtenerRutaAvatar(avatar: unknown): string {
    return `/avatars/${normalizarAvatarId(avatar)}.svg`;
}
